import { render, staticRenderFns } from "./new-renew-ticket-dialog.vue?vue&type=template&id=5f8f3ab4&scoped=true&"
import script from "./new-renew-ticket-dialog.vue?vue&type=script&lang=js&"
export * from "./new-renew-ticket-dialog.vue?vue&type=script&lang=js&"
import style0 from "./new-renew-ticket-dialog.vue?vue&type=style&index=0&id=5f8f3ab4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8f3ab4",
  null
  
)

export default component.exports